// Lib
import { withState } from '../../../node_module_clones/recompose';

export default withState('selectionMarqueeActive', 'setSelectionMarqueeActive', false);
